// extracted by mini-css-extract-plugin
module.exports = {"opener":"Tooltip_opener__O7zls","popup":"Tooltip_popup__wYsnx"};